import {DOCUMENT} from '@angular/common';
import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';

const ONG_API_KEY_HEADER = 'X-Api-Key';
const ONG_API_KEY_TOKEN = 'ONG_KEY';
const ONG_URL_TOKEN = 'ONG_URL';
const MAP_PROXY_PATH = '/api/mapservices/proxy';

/** Adds the server-resolved ONG key token to same-origin ONG requests sent through the map proxy. */
export const ongApiKeyInterceptor: HttpInterceptorFn = (request, next) => {
    const document = inject(DOCUMENT);

    if (!isProxiedOngRequest(request.urlWithParams, document.baseURI) || request.headers.has(ONG_API_KEY_HEADER)) {
        return next(request);
    }

    return next(
        request.clone({
            setHeaders: {[ONG_API_KEY_HEADER]: ONG_API_KEY_TOKEN},
        }),
    );
};

/** Returns true only for same-origin map-proxy URLs whose remote target starts with the ONG URL token. */
function isProxiedOngRequest(requestUrl: string, applicationUrl: string): boolean {
    const url = new URL(requestUrl, applicationUrl);
    const applicationOrigin = new URL(applicationUrl).origin;
    const proxyTarget = url.searchParams.get('url');

    return (
        url.origin === applicationOrigin &&
        url.pathname === MAP_PROXY_PATH &&
        (proxyTarget === ONG_URL_TOKEN || proxyTarget?.startsWith(`${ONG_URL_TOKEN}/`) === true)
    );
}
